import React, { useState, useEffect } from "react";
import "./Namuna.css";

const GramPanchayatNamuna8 = () => {

  const [printRecord, setPrintRecord] = useState(null);

  const [gramName, setGramName] = useState("भलेवाडी  ");
  const [taluka, setTaluka] = useState(" कारंजा (घा)");
  const [district, setDistrict] = useState("वर्धा");
  const [yearStart, setYearStart] = useState("2025");
  const [yearEnd, setYearEnd] = useState("2028 ");

  const [formData, setFormData] = useState({
    roadName: "",
    citySurveyNo: "",
    propertyNo: "",
    ownerName: "",
    occupierName: "",
    propertyType: "",
    constructionYear: "",
    area: "",
    landRate: "",
    buildingRate: "",
    constructionRate: "",
    depreciationRate: "",
    usageFactor: "1",
    rentalValue: "",
    taxRatePaise: "",
    houseTax: "",
    lightTax: "",
    healthTax: "",
    waterTax: "",
    appealHouse: "",
    appealLight: "",
    appealHealth: "",
    appealWater: "",
    shera: "",
  });

  // ✅ FIXED: Load data directly from localStorage
  const [records, setRecords] = useState(() => {
    try {
      const saved = localStorage.getItem("namuna8ModernRecords");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const [editingId, setEditingId] = useState(null);

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("namuna8ModernRecords", JSON.stringify(records));
  }, [records]);

  const totalTax =
    (parseFloat(formData.houseTax) || 0) +
    (parseFloat(formData.lightTax) || 0) +
    (parseFloat(formData.healthTax) || 0) +
    (parseFloat(formData.waterTax) || 0);

  const appealTotal =
    (parseFloat(formData.appealHouse) || 0) +
    (parseFloat(formData.appealLight) || 0) +
    (parseFloat(formData.appealHealth) || 0) +
    (parseFloat(formData.appealWater) || 0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      roadName: "",
      citySurveyNo: "",
      propertyNo: "",
      ownerName: "",
      occupierName: "",
      propertyType: "",
      constructionYear: "",
      area: "",
      landRate: "",
      buildingRate: "",
      constructionRate: "",
      depreciationRate: "",
      usageFactor: "1",
      rentalValue: "",
      taxRatePaise: "",
      houseTax: "",
      lightTax: "",
      healthTax: "",
      waterTax: "",
      appealHouse: "",
      appealLight: "",
      appealHealth: "",
      appealWater: "",
      shera: "",
    });

    setEditingId(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.ownerName || !formData.propertyNo) {
      alert("मालकाचे नाव आणि मालमत्ता क्रमांक भरा");
      return;
    }

    const newRecord = {
      id: editingId || Date.now(),
      sr: records.length + 1,
      ...formData,
      totalTax,
      appealTotal,
      dateAdded: new Date().toLocaleDateString("hi-IN"),
    };

    if (editingId) {
      // ✅ UPDATE CORRECTLY (on full records, not currentRecords)
      setRecords(records.map((r) => (r.id === editingId ? newRecord : r)));
    } else {
      // ✅ ADD NEW
      setRecords([newRecord, ...records]);
    }

    resetForm();
  };

  const handleEdit = (record) => {
    setFormData({
      roadName: record.roadName || "",
      citySurveyNo: record.citySurveyNo || "",
      propertyNo: record.propertyNo || "",
      ownerName: record.ownerName || "",
      occupierName: record.occupierName || "",
      propertyType: record.propertyType || "",
      constructionYear: record.constructionYear || "",
      area: record.area || "",
      landRate: record.landRate || "",
      buildingRate: record.buildingRate || "",
      constructionRate: record.constructionRate || "",
      depreciationRate: record.depreciationRate || "",
      usageFactor: record.usageFactor || "1",
      rentalValue: record.rentalValue || "",
      taxRatePaise: record.taxRatePaise || "",
      houseTax: record.houseTax || "",
      lightTax: record.lightTax || "",
      healthTax: record.healthTax || "",
      waterTax: record.waterTax || "",
      appealHouse: record.appealHouse || "",
      appealLight: record.appealLight || "",
      appealHealth: record.appealHealth || "",
      appealWater: record.appealWater || "",
      shera: record.shera || "",
    });

    setEditingId(record.id);
  };

  const handleDelete = (id) => {
    if (window.confirm("ही मालमत्ता नोंद कायमची काढून टाकायची आहे का?")) {
      setRecords(records.filter((r) => r.id !== id));
    }
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = records.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(records.length / recordsPerPage);

  const handlePrint = (record) => {
  // ✅ Fill form with selected row data
  setFormData({
    roadName: record.roadName || "",
    citySurveyNo: record.citySurveyNo || "",
    propertyNo: record.propertyNo || "",
    ownerName: record.ownerName || "",
    occupierName: record.occupierName || "",
    propertyType: record.propertyType || "",
    constructionYear: record.constructionYear || "",
    area: record.area || "",
    landRate: record.landRate || "",
    buildingRate: record.buildingRate || "",
    constructionRate: record.constructionRate || "",
    depreciationRate: record.depreciationRate || "",
    usageFactor: record.usageFactor || "1",
    rentalValue: record.rentalValue || "",
    taxRatePaise: record.taxRatePaise || "",
    houseTax: record.houseTax || "",
    lightTax: record.lightTax || "",
    healthTax: record.healthTax || "",
    waterTax: record.waterTax || "",
    appealHouse: record.appealHouse || "",
    appealLight: record.appealLight || "",
    appealHealth: record.appealHealth || "",
    appealWater: record.appealWater || "",
    shera: record.shera || "",
  });

  // ⏳ Wait for state update then print
  setTimeout(() => {
    window.print();
  }, 200);
};


  const [selectedRecord, setSelectedRecord] = useState(null);

  return (
    <div className="page-container">
      <div className="container">

           <div className="pdf-viewer-section">
  <h3>📄 नमुना क्र. ८ (PDF)</h3>

  <iframe
    src="/images/namuna8.pdf"
    title="Namuna 8 PDF"
    className="pdf-viewer"
  />

  <a
    href="/images/namuna8.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="pdf-download-btn"
  >
    PDF डाउनलोड करा
  </a>
</div> 
        <div className="namuna-header">
          <div className="namuna-header-box">
            <span className="namuna-header-icon">📋</span>

            <div className="namuna-header-title">
              नमुना नं. ८
            </div>

            <div className="namuna-header-subtitle">
              कर आकारणी नोंदवही
            </div>
          </div>
          <div className="namuna-header-info">
            ग्रामपंचायत :
            <input value={gramName} onChange={(e)=>setGramName(e.target.value)} />

            ता.
            <input value={taluka} onChange={(e)=>setTaluka(e.target.value)} />

            जि.
            <input value={district} onChange={(e)=>setDistrict(e.target.value)} />

            सन
            <input value={yearStart} onChange={(e)=>setYearStart(e.target.value)} />
            ते
            <input value={yearEnd} onChange={(e)=>setYearEnd(e.target.value)} />
          </div>
        </div>

        <div className="card">
          <h2 className="card-title">
            {editingId ? "📝 मालमत्ता संपादित करा" : "➕ नवी मालमत्ता जोडा"}
          </h2>



               

          <form onSubmit={handleSubmit} className="grid grid-3">

            <input name="roadName" placeholder="रस्त्याचे नाव" value={formData.roadName} onChange={handleChange} />
            <input name="citySurveyNo" placeholder="सिटी सर्व्हे क्र." value={formData.citySurveyNo} onChange={handleChange} />
            <input name="propertyNo" placeholder="मालमत्ता क्र." value={formData.propertyNo} onChange={handleChange} required />

            <input name="ownerName" placeholder="मालकाचे नाव" value={formData.ownerName} onChange={handleChange} required />
            <input name="occupierName" placeholder="भोगवटादार" value={formData.occupierName} onChange={handleChange} />

            <input name="area" type="number" placeholder="क्षेत्रफळ" value={formData.area} onChange={handleChange} />

            <input name="houseTax" type="number" placeholder="घरपट्टी कर" value={formData.houseTax} onChange={handleChange}/>
            <input name="lightTax" type="number" placeholder="दिवाबत्ती कर" value={formData.lightTax} onChange={handleChange}/>
            <input name="healthTax" type="number" placeholder="आरोग्य कर" value={formData.healthTax} onChange={handleChange}/>
            <input name="waterTax" type="number" placeholder="पाणीपट्टी कर" value={formData.waterTax} onChange={handleChange}/>

            <textarea name="shera" placeholder="शेरा" value={formData.shera} onChange={handleChange}></textarea>

            <div className="total-box total-tax">
              एकूण कर : ₹ {totalTax}
            </div>

            <div className="button-group">
              <button className="btn btn-primary">
                {editingId ? "अपडेट करा" : "नोंद जोडा"}
              </button>

              {editingId && (
                <button type="button" onClick={resetForm} className="btn btn-secondary">
                  रद्द करा
                </button>
              )}
            </div>

          </form>


        


        </div>

        <div className="card">

          <div style={{display:"flex",justifyContent:"space-between"}}>
            <h2>नोंदवलेल्या मालमत्ता</h2>
            <button onClick={handlePrint} className="btn-print no-print">
              🖨️ प्रिंट
            </button>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र</th>
                  <th>मालमत्ता क्र.</th>
                  <th>मालक</th>
                  <th>क्षेत्रफळ</th>
                  <th>एकूण कर</th>
                  <th className="no-print">क्रिया</th>
                </tr>
              </thead>

              <tbody>
                {currentRecords.map((r, i)=>(
                  <tr key={r.id}>
                    <td>{indexOfFirst + i + 1}</td>
                    <td>{r.propertyNo}</td>
                    <td>{r.ownerName}</td>
                    <td>{r.area}</td>
                    <td className="text-green">₹ {r.totalTax}</td>
                    <td className="no-print text-center">
                      <button onClick={()=>handleEdit(r)}>Edit</button>
                      <button onClick={()=>handleDelete(r.id)}>Delete</button>
                      <button onClick={() => handlePrint(r)}>Print</button>
                    </td>
                  </tr>
                ))}
              </tbody>
              
              <div className="pagination no-print">
                <button disabled={currentPage===1} onClick={()=>setCurrentPage(currentPage-1)}>
                  Prev
                </button>

                <span>Page {currentPage} / {totalPages}</span>

                <button disabled={currentPage===totalPages} onClick={()=>setCurrentPage(currentPage+1)}>
                  Next
                </button>
              </div>

            </table>
            {printRecord && (
              <div className="print-only">
                <h2>नमुना नं. ८</h2>
                <p>मालमत्ता क्र.: {printRecord.propertyNo}</p>
                <p>मालकाचे नाव: {printRecord.ownerName}</p>
                <p>क्षेत्रफळ: {printRecord.area}</p>
                <p>घरपट्टी: ₹ {printRecord.houseTax}</p>
                <p>दिवाबत्ती: ₹ {printRecord.lightTax}</p>
                <p>आरोग्य: ₹ {printRecord.healthTax}</p>
                <p>पाणीपट्टी: ₹ {printRecord.waterTax}</p>
                <h3>एकूण कर: ₹ {printRecord.totalTax}</h3>
                <p>शेरा: {printRecord.shera}</p>
              </div>
            )}
          </div>

        </div>

      </div>
    </div>
  );
};

export default GramPanchayatNamuna8;